import { Box } from '@mui/material';
import { ReactNode } from 'react';

const FormStep = ({ children }: { children: ReactNode }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
      }}
    >
      {children}
    </Box>
  );
};

export default FormStep;
